export default __webpack_public_path__ + "static/media/cs_icon_08_on.1e8894cc.png";